import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="max-w-3xl mx-auto py-10 space-y-8 animate-fade-in">
      <div>
        <Link to="/" className="text-zinc-500 text-sm hover:text-white transition-colors">← Back to StagePass</Link>
        <h1 className="text-3xl font-black text-white mt-4 mb-2">Privacy Policy</h1>
        <p className="text-zinc-500 text-sm">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
      </div>

      {[
        {
          title: "1. Information We Collect",
          body: "We collect information you provide directly to us, such as when you create an account, upload content, or contact us for support. This includes: account information (name, email, password), profile information (bio, location, genres, social links), content you upload (videos, audio, images), and usage data such as pages visited and features used.",
        },
        {
          title: "2. How We Use Your Information",
          body: "We use the information we collect to provide, maintain, and improve the StagePass platform, process transactions, send transactional and promotional communications, monitor and analyze usage trends, and comply with legal obligations. We do not sell your personal information to third parties.",
        },
        {
          title: "3. Firebase and Data Storage",
          body: "StagePass uses Google Firebase services for authentication, database storage (Firestore), and media storage (Firebase Storage). Your data is stored securely on Google's infrastructure. Please review Google's privacy policy for more information on how Google handles data.",
        },
        {
          title: "4. Content and Media",
          body: "Audio, video, and image files you upload are stored in Firebase Storage. By uploading content, you grant StagePass a non-exclusive, royalty-free license to display and distribute your content through the platform. You retain ownership of your content and are responsible for ensuring you have the necessary rights to upload it.",
        },
        {
          title: "5. Sharing of Information",
          body: "We may share your information with service providers who assist in operating the platform, when required by law, or to protect the rights and safety of StagePass and its users. Public profile information (display name, bio, genres) is visible to all users of the platform.",
        },
        {
          title: "6. Data Retention",
          body: "We retain your information for as long as your account is active or as needed to provide services. You may delete your account at any time. Upon account deletion, your personal information will be removed, though content shared publicly may remain visible for a period while caches clear.",
        },
        {
          title: "7. Your Rights",
          body: "Depending on your location, you may have rights to access, correct, or delete your personal information. To exercise these rights, contact us at privacy@stagepassaccess.com.",
        },
        {
          title: "8. Contact Us",
          body: "If you have questions about this Privacy Policy, please contact us at privacy@stagepassaccess.com or visit stagepassaccess.com.",
        },
      ].map((section) => (
        <section key={section.title} className="bg-[#111] border border-white/5 rounded-2xl p-5">
          <h2 className="text-white font-bold text-base mb-3">{section.title}</h2>
          <p className="text-zinc-400 text-sm leading-relaxed">{section.body}</p>
        </section>
      ))}
    </div>
  );
}
